///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('.js-sticky-submit-button')) {
      window.addEventListener('scroll', () => {
        const saveButton = document.querySelector('.js-sticky-submit-button'),
              scrollPosition = Math.round(window.pageYOffset);

        scrollPositionCheck(scrollPosition, saveButton);
      });
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Checks scroll position to decide if the save
  //               button should be hidden or shown.
  //
  function scrollPositionCheck(scrollPosition, saveButton) {
    if (scrollPosition >= 500) {
      saveButton.classList.remove('d-none');
    } else {
      saveButton.classList.add('d-none');
    }
  }
})();
